__turbopack_context__.v({
  "disabled": "Input-module-scss-module__7iAVxa__disabled",
  "error": "Input-module-scss-module__7iAVxa__error",
  "field": "Input-module-scss-module__7iAVxa__field",
  "focused": "Input-module-scss-module__7iAVxa__focused",
  "icon_slot": "Input-module-scss-module__7iAVxa__icon_slot",
  "input": "Input-module-scss-module__7iAVxa__input",
  "input_area": "Input-module-scss-module__7iAVxa__input_area",
  "label": "Input-module-scss-module__7iAVxa__label",
  "label_hidden": "Input-module-scss-module__7iAVxa__label_hidden",
  "required": "Input-module-scss-module__7iAVxa__required",
  "size_lg": "Input-module-scss-module__7iAVxa__size_lg",
  "size_md": "Input-module-scss-module__7iAVxa__size_md",
  "size_sm": "Input-module-scss-module__7iAVxa__size_sm",
  "spinner": "Input-module-scss-module__7iAVxa__spinner",
  "suffix": "Input-module-scss-module__7iAVxa__suffix",
  "unit": "Input-module-scss-module__7iAVxa__unit",
  "view": "Input-module-scss-module__7iAVxa__view",
  "wrapper": "Input-module-scss-module__7iAVxa__wrapper",
});
